// ============ MOCK DATA for BOSSY (Kelly & Kelly) ============
// All data here is MOCKED for the frontend preview. Real backend can replace later.

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Podcast", to: "/podcast" },
  { label: "Guests", to: "/guests" },
  { label: "Blog", to: "/blog" },
  { label: "Speaking", to: "/speaking" },
  { label: "Work With Us", to: "/work-with-us" },
  { label: "Community", to: "/community" },
  { label: "Shop", to: "/shop" },
];

export const brand = {
  name: "BOSSY",
  tagline: "Kelly & Kelly",
  est: "Since 2014",
  heroImage:
    "https://images.pexels.com/photos/8424878/pexels-photo-8424878.jpeg",
  stats: [
    { value: "15+", label: "years in business" },
    { value: "85+", label: "podcast episodes" },
    { value: "9", label: "businesses built" },
  ],
};

export const homeTiles = [
  {
    title: "BOSSY Community",
    img: "https://images.unsplash.com/photo-1590650046871-92c887180603",
    text:
      "A private space where women business owners share the real stuff — truths, questions, wins, and worries — inside a supportive, members-only forum with 10+ years of content to search.",
    cta: "Join the Group",
    to: "/community",
  },
  {
    title: "Podcast",
    img: "https://images.unsplash.com/photo-1610733661495-4aa6ed9fc6f4?crop=entropy&cs=srgb&fm=jpg&q=85",
    text:
      "Getting Real with BOSSY is where we sit down with business owners — and each other — and hear the true, honest, and raw stories of what it actually takes to build and run a business.",
    cta: "Listen Now",
    to: "/podcast",
  },
  {
    title: "Blog",
    img: "https://images.unsplash.com/photo-1488751045188-3c55bbf9a3fa",
    text:
      "Real-world advice, honest stories, and a healthy dose of humor to support and inspire you through every messy, magical stage of business ownership.",
    cta: "Read the Blog",
    to: "/blog",
  },
];

// ---------------- PODCAST ----------------
export const podcastMeta = {
  title: "Getting Real with BOSSY",
  cover:
    "https://images.pexels.com/photos/38493054/pexels-photo-38493054.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  description:
    "No highlight reels. Two Kellys sit down with real business owners to talk about the cash-flow scares, the burnout, the wins nobody saw, and the decisions that kept them up at night.",
  subscribeLinks: [
    { name: "Spotify", url: "#" },
    { name: "Apple Podcasts", url: "#" },
    { name: "YouTube", url: "#" },
  ],
};

export const episodes = [
  {
    id: "ep-87",
    number: 87,
    title: "The Real Cost of Founder Burnout",
    guest: "Erika Sorbello",
    guestRole: "Founder, Bright Path Studios",
    guestBio:
      "Erika scaled a design studio from her kitchen table to a 12-person team — then nearly walked away. She joins us to talk about the warning signs she ignored and the systems that brought her back.",
    guestImg: "https://images.pexels.com/photos/7971746/pexels-photo-7971746.jpeg",
    duration: "48 min",
    date: "Jul 8, 2025",
    pillar: "Founder Psychology",
    summary:
      "Founder burnout is the slow erosion of energy, clarity, and joy caused by carrying too much for too long. In this episode we break down the physical and financial warning signs, and the boundaries that protect your business.",
    showNotes: [
      "The three burnout stages most owners miss",
      "Why 'just push through' costs you money",
      "Erika's 20-minute weekly reset ritual",
      "How to delegate before you break",
    ],
    thumb: "https://images.unsplash.com/photo-1620034820336-106a6bd3299a",
  },
  {
    id: "ep-86",
    number: 86,
    title: "Pricing Like You Mean It",
    guest: "Iris Zimmerman",
    guestRole: "Pricing Strategist",
    guestBio:
      "Iris helps women-owned businesses stop undercharging. She's rescued dozens of founders from the discount trap and joins us to make raising your prices feel less terrifying.",
    guestImg: "https://images.pexels.com/photos/27086165/pexels-photo-27086165.jpeg",
    duration: "52 min",
    date: "Jun 24, 2025",
    pillar: "Money & Financial Confidence",
    summary:
      "Confident pricing starts with knowing your numbers and your worth. We cover the scripts, the math, and the mindset shift that lets you raise prices without losing your best clients.",
    showNotes: [
      "Why women undervalue their services",
      "The 'value ladder' pricing method",
      "How to announce a price increase",
      "Handling the one client who pushes back",
    ],
    thumb: "https://images.unsplash.com/photo-1620275765334-4ed948bb4502",
  },
  {
    id: "ep-85",
    number: 85,
    title: "Hiring Before You're Ready",
    guest: "Megan Mills",
    guestRole: "Operations Consultant",
    guestBio:
      "Megan has built teams for restaurants, agencies, and nonprofits. She unpacks how to know when it's truly time to hire — and how to not screw up the first one.",
    guestImg: "https://images.pexels.com/photos/8373928/pexels-photo-8373928.jpeg",
    duration: "45 min",
    date: "Jun 10, 2025",
    pillar: "Leadership & Growth",
    summary:
      "Knowing when to hire is a math problem and a gut problem. We give you the readiness checklist and the human-centered onboarding that keeps your first hire from becoming your first regret.",
    showNotes: [
      "The 'are you ready to hire' checklist",
      "Contractor vs employee, plainly explained",
      "Writing a job post people actually answer",
      "First 30 days that build loyalty",
    ],
    thumb: "https://images.unsplash.com/photo-1517048676732-d65bc937f952",
  },
  {
    id: "ep-84",
    number: 84,
    title: "When the Business Almost Blew Up",
    guest: "Alison Jacobson",
    guestRole: "Restaurant Owner",
    guestBio:
      "Alison survived a near-collapse during a supply crisis. She shares the crisis playbook she wishes she'd had, and how she rebuilt trust with her team.",
    guestImg: "https://images.pexels.com/photos/8424878/pexels-photo-8424878.jpeg",
    duration: "50 min",
    date: "May 27, 2025",
    pillar: "Business Operations & Risk",
    summary:
      "Business risk management means spotting operational, financial, and legal threats before they become crises. Alison walks us through the week everything went wrong and the continuity plan that saved her.",
    showNotes: [
      "The early signals of a cash crunch",
      "Building a 90-day continuity plan",
      "Communicating with your team under pressure",
      "What she'd insure differently now",
    ],
    thumb: "https://images.unsplash.com/photo-1529651737248-dad5e287768e?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "ep-83",
    number: 83,
    title: "The Loneliness Nobody Warns You About",
    guest: "The Kellys",
    guestRole: "Co-hosts",
    guestBio:
      "Just the two Kellys this week, getting honest about founder loneliness — why it happens, why it's not weakness, and what actually helps.",
    guestImg: "https://images.unsplash.com/photo-1581404917879-53e19259fdda",
    duration: "39 min",
    date: "May 13, 2025",
    pillar: "Founder Psychology",
    summary:
      "Founder loneliness is the isolation that comes from carrying decisions no one else fully understands. We talk about building a real support bench and why community is a business strategy.",
    showNotes: [
      "Why the top is quiet and lonely",
      "The difference between a peer and a cheerleader",
      "How BOSSY started as an antidote to this",
      "Small rituals that reconnect you",
    ],
    thumb: "https://images.unsplash.com/photo-1543269865-cbf427effbad",
  },
  {
    id: "ep-82",
    number: 82,
    title: "Marketing When You Hate Marketing",
    guest: "Dana Ruiz",
    guestRole: "Fractional CMO",
    guestBio:
      "Dana demystifies marketing for owners who'd rather do anything else. Practical, no-jargon, and refreshingly honest about what actually moves the needle.",
    guestImg: "https://images.pexels.com/photos/7971746/pexels-photo-7971746.jpeg",
    duration: "44 min",
    date: "Apr 29, 2025",
    pillar: "Marketing & Visibility",
    summary:
      "Good marketing is being findable and trustworthy when someone is ready to buy. Dana shares the tiny, repeatable habits that build visibility without a big budget or a big following.",
    showNotes: [
      "The one Google Business Profile fix",
      "Reviews: how to ask without cringing",
      "A weekly content habit that compounds",
      "AI search and why summaries matter",
    ],
    thumb: "https://images.unsplash.com/photo-1513128034602-7814ccaddd4e?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

// ---------------- BLOG (topic clusters / pillars) ----------------
export const blogPillars = [
  {
    slug: "founder-psychology",
    title: "Founder Psychology",
    color: "#d0673d",
    blurb:
      "Running a business isn't just about strategy — it's about managing yourself. Burnout, confidence, decision fatigue, mindset, and resilience.",
    img: "https://images.unsplash.com/photo-1620034820336-106a6bd3299a",
  },
  {
    slug: "business-operations-risk",
    title: "Business Operations & Risk",
    color: "#2f8f9b",
    blurb:
      "Cash flow, insurance, systems, legal basics, crisis planning, and SOPs — the unglamorous work that keeps the doors open.",
    img: "https://images.unsplash.com/photo-1517048676732-d65bc937f952",
  },
  {
    slug: "marketing-visibility",
    title: "Marketing & Visibility",
    color: "#c9a24b",
    blurb:
      "SEO, AI search, Google Business Profile, social media, PR, branding, and reviews — becoming findable and trusted.",
    img: "https://images.unsplash.com/photo-1488751045188-3c55bbf9a3fa",
  },
  {
    slug: "leadership-growth",
    title: "Leadership & Growth",
    color: "#24405f",
    blurb:
      "Hiring, delegation, culture, difficult conversations, scaling, and productivity — leading people without losing yourself.",
    img: "https://images.unsplash.com/photo-1550305080-4e029753abcf",
  },
  {
    slug: "money-financial-confidence",
    title: "Money & Financial Confidence",
    color: "#4fb3bf",
    blurb:
      "Pricing, profit, budgeting, taxes, financial literacy, and business metrics — plain-talk money for owners.",
    img: "https://images.unsplash.com/photo-1620275765334-4ed948bb4502",
  },
];

export const blogPosts = [
  {
    slug: "burnout-warning-signs",
    title: "Burnout Warning Signs Every Founder Should Know",
    pillar: "founder-psychology",
    pillarLabel: "Founder Psychology",
    author: "Kelly Metras",
    date: "Jul 15, 2025",
    readTime: "6 min",
    img: "https://images.unsplash.com/photo-1620034820336-106a6bd3299a",
    aiSummary:
      "Founder burnout is the gradual loss of energy, clarity, and motivation caused by sustained overwork and unmanaged stress. Watch for cynicism, dropped routines, and dreading work you once loved — and act before it becomes a crisis.",
    excerpt:
      "You don't wake up burned out. It builds — quietly — until one Tuesday you can't remember why you started. Here are the signals to catch early.",
    body: [
      "Burnout rarely announces itself. It creeps in through skipped lunches, short tempers, and a growing sense that nothing you do is enough.",
      "The first stage is physical: disrupted sleep, tension headaches, that wired-but-tired feeling. The second is emotional — cynicism about work you used to love. The third is a performance drop you keep blaming on everything but yourself.",
      "The fix isn't a vacation. It's boundaries, delegation, and building a support bench before you need one. Start by protecting one non-negotiable hour a week that belongs only to you.",
    ],
  },
  {
    slug: "why-women-undervalue-services",
    title: "Why Women Undervalue Their Services (and How to Stop)",
    pillar: "money-financial-confidence",
    pillarLabel: "Money & Financial Confidence",
    author: "Kelly Bush",
    date: "Jul 2, 2025",
    readTime: "7 min",
    img: "https://images.unsplash.com/photo-1620275765334-4ed948bb4502",
    aiSummary:
      "Women often underprice because of socialized modesty, fear of pushback, and unclear value metrics. Confident pricing starts with knowing your numbers, anchoring to outcomes, and practicing the ask.",
    excerpt:
      "If raising your prices makes you queasy, you're not alone — and you're probably leaving real money on the table.",
    body: [
      "Underpricing is rarely a math problem. It's a story problem — the quiet belief that charging more makes you greedy, or that someone will finally say 'who do you think you are?'",
      "Start with the numbers: know your true costs, your target profit, and the outcome you deliver. Anchor your price to that outcome, not to the hours.",
      "Then practice the sentence out loud until it stops shaking. 'My rate is X.' No apology, no over-explaining. Silence after the number is your friend.",
    ],
  },
  {
    slug: "business-risk-assessment",
    title: "Business Risk Management for Small Businesses",
    pillar: "business-operations-risk",
    pillarLabel: "Business Operations & Risk",
    author: "Kelly Metras",
    date: "Jun 20, 2025",
    readTime: "8 min",
    img: "https://images.unsplash.com/photo-1517048676732-d65bc937f952",
    aiSummary:
      "Business risk management is the process of identifying, evaluating, and reducing operational, financial, legal, and market risks before they become crises. Small business owners should review their risks at least annually and after major changes.",
    excerpt:
      "You can't eliminate risk, but you can stop it from surprising you. A simple, once-a-year review changes everything.",
    body: [
      "Every business runs on risk. The goal isn't to remove it — it's to see it coming and have a plan.",
      "Group your risks into four buckets: operational (people, supply, systems), financial (cash flow, debt), legal (contracts, compliance), and market (demand, competition). Rate each by likelihood and impact.",
      "Then build a one-page continuity plan: who does what if the worst happens, where the money comes from, and how you'll communicate. Revisit it every year and after any big change.",
    ],
  },
  {
    slug: "founder-loneliness",
    title: "The Loneliness of Owning a Business",
    pillar: "founder-psychology",
    pillarLabel: "Founder Psychology",
    author: "Kelly Bush",
    date: "Jun 5, 2025",
    readTime: "5 min",
    img: "https://images.unsplash.com/photo-1543269865-cbf427effbad",
    aiSummary:
      "Founder loneliness is the isolation of carrying decisions and pressure that employees, friends, and family can't fully share. It's common and manageable — the antidote is a peer community that gets it.",
    excerpt:
      "Nobody warns you that the quietest part of success is how alone it can feel at the top.",
    body: [
      "Your team can't carry the weight of the payroll worry. Your friends glaze over when you talk margins. Your family sees the highlight reel.",
      "That gap — between what you carry and what others understand — is founder loneliness. It's not weakness. It's a structural feature of being the one who decides.",
      "The fix is peers who've been there. A room (or a forum) where you can say the scary thing out loud and hear 'me too.' That's exactly why BOSSY exists.",
    ],
  },
  {
    slug: "google-business-profile-fix",
    title: "The One Google Business Profile Fix That Wins Local Search",
    pillar: "marketing-visibility",
    pillarLabel: "Marketing & Visibility",
    author: "Kelly Metras",
    date: "May 22, 2025",
    readTime: "6 min",
    img: "https://images.unsplash.com/photo-1488751045188-3c55bbf9a3fa",
    aiSummary:
      "A complete, active Google Business Profile — accurate categories, photos, and steady reviews — is the highest-leverage local marketing move for small businesses and the content AI search engines cite most.",
    excerpt:
      "Before you spend a dollar on ads, spend an hour here. It's the cheapest visibility you'll ever buy.",
    body: [
      "Most owners set up a Google Business Profile once and forget it. That's the mistake.",
      "Pick the most specific primary category, add every service, post fresh photos monthly, and — the big one — ask happy customers for reviews consistently.",
      "AI search engines increasingly pull from structured, well-maintained profiles. A tidy profile isn't just for Google; it's how the whole internet decides you're legit.",
    ],
  },
  {
    slug: "hiring-first-employee",
    title: "How to Know You're Ready to Hire",
    pillar: "leadership-growth",
    pillarLabel: "Leadership & Growth",
    author: "Kelly Bush",
    date: "May 8, 2025",
    readTime: "7 min",
    img: "https://images.unsplash.com/photo-1550305080-4e029753abcf",
    aiSummary:
      "You're ready to hire when consistent overflow work is costing you revenue, you can cover the role for 3–6 months, and you can clearly describe the outcomes the role owns. Hire for capacity, not for rescue.",
    excerpt:
      "Hire too early and you drain cash. Hire too late and you drown. Here's how to find the line.",
    body: [
      "The wrong reason to hire is panic. The right reason is math plus clarity.",
      "Check three things: Is there steady overflow work you're turning away or doing badly? Can you fund the role for 3–6 months even if revenue dips? Can you describe, in one sentence, the outcome this person owns?",
      "If all three are yes, write the job around outcomes, not tasks — and plan a 30-day onboarding before you post it.",
    ],
  },
];

// ---------------- SHOP (fixed products, deduped, descriptions) ----------------
export const products = [
  {
    id: "reality-check",
    name: "Business Owner's Reality Check",
    price: 27.0,
    img: "https://images.unsplash.com/photo-1529651737248-dad5e287768e?crop=entropy&cs=srgb&fm=jpg&q=85",
    category: "Workbook",
    desc:
      "A 32-page guided workbook that walks you through an honest audit of your business — cash flow, capacity, and the numbers you've been avoiding. Includes prompts, worksheets, and a 90-day action plan.",
    preview: "12 pages • fillable PDF • lifetime access",
  },
  {
    id: "reality-check-free",
    name: "Business Owner's Reality Check — Free Preview",
    price: 0.0,
    img: "https://images.unsplash.com/photo-1513128034602-7814ccaddd4e?crop=entropy&cs=srgb&fm=jpg&q=85",
    category: "Free Download",
    desc:
      "A free 6-page sampler of the full Reality Check workbook. Try the first module — the cash-flow honesty check — before you buy the complete version.",
    preview: "6 pages • fillable PDF • free",
  },
  {
    id: "business-story-workbook",
    name: "The Business Story Workbook",
    price: 27.0,
    img: "https://images.unsplash.com/photo-1620275765334-4ed948bb4502",
    category: "Workbook",
    desc:
      "Craft the story behind your brand. This workbook helps you find the words for why you do what you do — for your website, your pitch, and your team.",
    preview: "28 pages • fillable PDF • lifetime access",
  },
  {
    id: "pricing-confidence",
    name: "Pricing Confidence Kit",
    price: 34.0,
    img: "https://images.unsplash.com/photo-1620034820336-106a6bd3299a",
    category: "Toolkit",
    desc:
      "Stop undercharging. A calculator, scripts for raising prices, and a value-ladder template so you can price to your worth — without losing your best clients.",
    preview: "Calculator + scripts • editable • lifetime access",
  },
  {
    id: "hire-ready",
    name: "Ready to Hire? Toolkit",
    price: 24.0,
    img: "https://images.unsplash.com/photo-1517048676732-d65bc937f952",
    category: "Toolkit",
    desc:
      "The readiness checklist, a plain-English contractor-vs-employee guide, job-post templates, and a 30-day onboarding plan for your first hire.",
    preview: "18 pages + templates • lifetime access",
  },
  {
    id: "continuity-plan",
    name: "Business Continuity Plan Template",
    price: 19.0,
    img: "https://images.unsplash.com/photo-1529651737248-dad5e287768e?crop=entropy&cs=srgb&fm=jpg&q=85",
    category: "Template",
    desc:
      "A fill-in-the-blank crisis plan: who does what, where the money comes from, and how you'll communicate when things go sideways.",
    preview: "One-page plan + guide • editable • lifetime access",
  },
];

// ---------------- WORK WITH US ----------------
export const services = [
  {
    id: "consulting",
    title: "Business Consulting",
    tagline: "Straight-talk strategy, one-on-one.",
    forWho: "Owners who need an experienced sounding board and a real plan.",
    format: "Monthly retainer • virtual or in-person",
    price: "From $750/mo",
    desc:
      "We roll up our sleeves with you on the stuff that's actually stuck — pricing, hiring, operations, or that decision you've been circling for months. No fluff, just two owners who've done it.",
    img: "https://images.pexels.com/photos/27086165/pexels-photo-27086165.jpeg",
  },
  {
    id: "before-it-blows-up",
    title: "Before It Blows Up",
    tagline: "Crisis-proof your business before you need to.",
    forWho: "Owners who feel the cracks forming and want a plan.",
    format: "2-week intensive • 3 sessions",
    price: "$1,200",
    desc:
      "A focused risk-and-resilience sprint. We map your operational, financial, and legal risks and build a one-page continuity plan so the next surprise is survivable.",
    img: "https://images.unsplash.com/photo-1517048676732-d65bc937f952",
  },
  {
    id: "bossy-for-a-day",
    title: "BOSSY for a Day",
    tagline: "One day. Your whole business, untangled.",
    forWho: "Owners drowning in decisions who need momentum fast.",
    format: "Full-day intensive • in-person or virtual",
    price: "$2,000",
    desc:
      "Both Kellys, one full day, entirely on your business. We leave you with clarity, a prioritized action list, and the energy to actually do it.",
    img: "https://images.pexels.com/photos/8373928/pexels-photo-8373928.jpeg",
  },
  {
    id: "entrepreneur-workshop",
    title: "Entrepreneur Workshop",
    tagline: "Real tools for a room full of owners.",
    forWho: "Associations, chambers, and groups of business owners.",
    format: "Half-day workshop • 10–35 people",
    price: "From $2,500",
    desc:
      "An interactive, no-buzzword workshop on the topics owners actually lose sleep over — pricing, hiring, burnout, and building systems that don't depend on you.",
    img: "https://images.pexels.com/photos/8761327/pexels-photo-8761327.jpeg",
  },
  {
    id: "founder-wiring",
    title: "Founder Wiring",
    tagline: "Build a business that fits how you're built.",
    forWho: "Owners who feel like they're fighting their own business.",
    format: "3-session program • virtual",
    price: "$600",
    desc:
      "Discover your leadership archetype and design a business around your strengths instead of someone else's playbook. Stop forcing the fit.",
    img: "https://images.unsplash.com/photo-1620034820336-106a6bd3299a",
  },
];

// ---------------- SPEAKING / CORPORATE SEMINARS ----------------
export const speaking = {
  hero: {
    headline: "Real Leadership Strategy. Zero Corporate Fluff.",
    subhead:
      "Dynamic keynotes and practical workshops designed to align teams, clarify operational accountability, and build resilient, sustainable organizations.",
    image:
      "https://images.unsplash.com/photo-1679579664878-2c025e3f87b0",
    primaryCta: "Inquire for Your Event",
    secondaryCta: "Download Speaker One-Sheet",
  },
  approach:
    "We skip the generic motivational buzzwords. Backed by decades of real-world restaurant operation, non-profit scaling, and small business navigation, we deliver hard-hitting, actionable frameworks that help leaders and teams communicate, execute, and grow without burnout.",
  hosts: [
    {
      name: "Kelly Bush",
      role:
        "Entrepreneurial founder & hospitality veteran — master of operational culture, brand mechanics, and high-stakes team management.",
      img: "https://images.pexels.com/photos/7971746/pexels-photo-7971746.jpeg",
    },
    {
      name: "Kelly Metras",
      role:
        "Strategic organizer & campaign driver — expert in community advocacy, executive alignment, and organizational infrastructure.",
      img: "https://images.pexels.com/photos/8424878/pexels-photo-8424878.jpeg",
    },
  ],
  modules: [
    {
      code: "Module A",
      title: "The Leadership Archetype Framework",
      focus: "Self-awareness, team dynamics, and conflict resolution.",
      learn: [
        "Identifying individual leadership archetypes within your team",
        "Navigating friction between Visionaries and Integrators",
        "Shifting from reactive firefighting to structured decision-making",
      ],
    },
    {
      code: "Module B",
      title: "Practical Accountability & Operational Scaling",
      focus: "Eliminating ambiguity and driving execution.",
      learn: [
        "Building human-centered accountability frameworks (SOPs people follow)",
        "Prioritizing high-impact operational metrics",
        "Managing burnout while maintaining performance during growth",
      ],
    },
    {
      code: "Module C",
      title: "Candid Communication & Workplace Culture",
      focus: "Internal transparency, alignment, and psychological safety.",
      learn: [
        "Holding uncomfortable, necessary conversations with radical candor",
        "Cultivating a culture of ownership, not deflection",
        "Aligning personal values with company mission to retain talent",
      ],
    },
  ],
  keynotes: [
    {
      title: "Getting Real About Growth",
      desc:
        "The unvarnished truth about scaling a business, managing cash flow, and surviving operational pivots.",
    },
    {
      title: "BOSSY Leadership",
      desc:
        "Redefining authority, ownership, and confidence in male-dominated or fast-moving industries.",
    },
    {
      title: "From Chaos to System",
      desc:
        "How to untangle founder dependencies and build self-sustaining team structures.",
    },
  ],
  facts: [
    {
      format: "Executive Keynote",
      duration: "45–60 Mins",
      audience: "50 – 500+",
      best: "Annual Conferences, Conventions, Summits",
    },
    {
      format: "Half-Day Workshop",
      duration: "3 Hours",
      audience: "10 – 35",
      best: "Executive Teams, Department Heads",
    },
    {
      format: "Full-Day Retreat",
      duration: "6 Hours",
      audience: "10 – 25",
      best: "Board Meetings, Leadership Offsites",
    },
  ],
};

// ---------------- ABOUT ----------------
export const timeline = [
  { year: "Before 2005", text: "Two Kellys meet in their 20s." },
  {
    year: "2008",
    text:
      "Kelly M. joins Kelly B. at Hillside Children's Center. The after-work debrief sessions begin.",
  },
  {
    year: "2010–2011",
    text:
      "Both Kellys open restaurants within a year of each other. The meetings continue — now with higher stakes.",
  },
  {
    year: "2014",
    text:
      "BOSSY Rochester is born — a networking and support community for women business owners in Rochester, NY.",
  },
  {
    year: "2021+",
    text: "Getting Real with BOSSY podcast launches. 85+ episodes and counting.",
  },
  {
    year: "2025",
    text:
      "Speakers at the Women in Hospitality Conference at Google, NYC. The brand goes national.",
  },
];

export const founders = [
  {
    name: "Kelly Bush",
    email: "bossyroc@gmail.com",
    img: "https://images.pexels.com/photos/7971746/pexels-photo-7971746.jpeg",
    bio:
      "Kelly Bush is a hospitality leader, entrepreneur, and unapologetic advocate for doing business differently. As co-owner of Union Tavern and Marshall Street Bar & Grill, and co-founder of BOSSY, she has built a career rooted in community, inclusivity, and real connection. Through speaking, consulting, and co-hosting Getting Real with BOSSY, Kelly shares the unfiltered realities of entrepreneurship.",
  },
  {
    name: "Kelly Metras",
    email: "bossyroc@gmail.com",
    img: "https://images.pexels.com/photos/8424878/pexels-photo-8424878.jpeg",
    bio:
      "Kelly Metras is an entrepreneur, community leader, and creative visionary based in Rochester, New York. She brings a blend of strategic thinking and emotional intelligence to her work — known for connecting people, cultivating strong teams, and creating environments where employees and clients feel valued. A passionate advocate for women in business, she co-hosts Getting Real with BOSSY.",
  },
];

export const beliefs = [
  {
    title: "Real over polished",
    text:
      "We talk about the hard stuff — the cash flow problems, the burnout, the decisions that kept you up at night. No highlight reel here.",
  },
  {
    title: "Support as a strategy",
    text:
      "Having the right people in your corner isn't soft — it's one of the most powerful business decisions you'll make.",
  },
  {
    title: "Done over perfect",
    text:
      "We've learned more from doing imperfect things than waiting for the right moment. We build in public and we mean it.",
  },
];

// ---------------- COMMUNITY ----------------
export const communityPerks = [
  "Members-only forum with 10+ years of searchable content",
  "Monthly live 'Getting Real' group calls with the Kellys",
  "First access to workshops, workbooks, and podcast guests",
  "A private space to ask the questions you can't ask anyone else",
  "Accountability pods with owners at your stage",
  "Guest directory and warm intros within the community",
];

export const membershipTiers = [
  {
    name: "Insider",
    price: "$19",
    period: "/mo",
    features: [
      "Members-only forum access",
      "Monthly group call",
      "Resource library",
    ],
    highlight: false,
  },
  {
    name: "BOSSY Circle",
    price: "$39",
    period: "/mo",
    features: [
      "Everything in Insider",
      "Accountability pods",
      "Workshop discounts",
      "Priority podcast Q&A",
    ],
    highlight: true,
  },
  {
    name: "Inner Table",
    price: "$99",
    period: "/mo",
    features: [
      "Everything in Circle",
      "Quarterly 1:1 with a Kelly",
      "Free workbooks",
      "Speaking/collab intros",
    ],
    highlight: false,
  },
];

// ---------------- ASSESSMENTS / QUIZ ----------------
export const burnoutQuiz = {
  title: "Founder Burnout Quiz",
  subtitle:
    "Ten honest questions. Two minutes. A clear read on where you stand — and what to do next.",
  img: "https://images.unsplash.com/photo-1620034820336-106a6bd3299a",
  questions: [
    "I wake up already dreading my to-do list.",
    "My sleep has been disrupted or restless lately.",
    "I've become more cynical or short-tempered about work I used to love.",
    "I keep skipping meals, breaks, or workouts to 'get more done'.",
    "I feel like everything depends on me and can't be delegated.",
    "I struggle to switch off, even on days off.",
    "Small decisions feel exhausting or paralyzing.",
    "I feel more isolated in my business than I did a year ago.",
    "My performance has dropped and I keep pushing harder anyway.",
    "I can't remember the last time I felt genuinely excited about my work.",
  ],
  results: [
    {
      max: 3,
      label: "Running Warm",
      color: "#2f8f9b",
      text:
        "You're managing — but a few warning lights are on. Protect your boundaries now and they won't become alarms. Read our Burnout Warning Signs guide.",
    },
    {
      max: 6,
      label: "Overheating",
      color: "#c9a24b",
      text:
        "You're carrying more than is sustainable. It's time to delegate something real this week and build a support bench. Consider a Founder Wiring session.",
    },
    {
      max: 10,
      label: "Burning Out",
      color: "#d0673d",
      text:
        "This is your signal to stop pushing through. You need boundaries, support, and probably a real conversation with someone who gets it. Let's talk — book a BOSSY for a Day.",
    },
  ],
};

export const otherAssessments = [
  { title: "Are You Ready to Hire?", tag: "Leadership", q: "8 questions" },
  { title: "Pricing Confidence Assessment", tag: "Money", q: "10 questions" },
  { title: "Cash Flow Health Check", tag: "Operations", q: "12 questions" },
  { title: "Delegation Scorecard", tag: "Leadership", q: "9 questions" },
  { title: "Marketing Maturity Assessment", tag: "Marketing", q: "10 questions" },
  { title: "Time Management Audit", tag: "Productivity", q: "8 questions" },
];

// ---------------- RESOURCE LIBRARY ----------------
export const resources = [
  {
    id: "business-plan-template",
    title: "Business Plan Template",
    type: "Template",
    desc: "A lean, fill-in-the-blank plan you'll actually finish.",
    img: "https://images.unsplash.com/photo-1513128034602-7814ccaddd4e?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "pricing-calculator",
    title: "Pricing Calculator",
    type: "Tool",
    desc: "Plug in your costs and target profit; get a confident price.",
    img: "https://images.unsplash.com/photo-1620275765334-4ed948bb4502",
  },
  {
    id: "cash-flow-worksheet",
    title: "Cash Flow Worksheet",
    type: "Worksheet",
    desc: "See the next 90 days before they surprise you.",
    img: "https://images.unsplash.com/photo-1529651737248-dad5e287768e?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "new-hire-checklist",
    title: "New Hire Checklist",
    type: "Checklist",
    desc: "A 30-day onboarding that builds loyalty from day one.",
    img: "https://images.unsplash.com/photo-1517048676732-d65bc937f952",
  },
  {
    id: "crisis-comms-checklist",
    title: "Crisis Communication Checklist",
    type: "Checklist",
    desc: "Who says what, to whom, when things go sideways.",
    img: "https://images.unsplash.com/photo-1620034820336-106a6bd3299a",
  },
  {
    id: "weekly-ceo-planner",
    title: "Weekly CEO Planner",
    type: "Planner",
    desc: "Run your week like the CEO you actually are.",
    img: "https://images.unsplash.com/photo-1488751045188-3c55bbf9a3fa",
  },
];

export const testimonials = [
  {
    quote:
      "Business ownership is messy, scary, and amazing. You deserve people who tell the truth and stand in it with you.",
    name: "The Kellys",
    role: "Co-founders, BOSSY",
  },
  {
    quote:
      "BOSSY is the first place I've felt safe saying 'I have no idea what I'm doing' out loud. Turns out, neither did anyone — and we figured it out together.",
    name: "Marisa L.",
    role: "Bakery Owner",
  },
  {
    quote:
      "The pricing episode alone paid for a decade of membership. I finally raised my rates and nobody left.",
    name: "Priya S.",
    role: "Studio Founder",
  },
];
